import { getService } from '../utils';

/**
 * Ask updater-bot to switch to the USB (offline) build when an online download
 * is blocking the offline auto-loader. feathers-bot cancels the in-flight
 * online download (`onlineBuildId`) and persists the offline selection so the
 * online target can't re-adopt the slot until the USB build installs or the
 * drive is removed.
 */
export async function requestSwitchToOffline(
  onlineBuildId: string,
  offlineUpdatePath: string,
): Promise<void> {
  const dataService = getService('softwareUpdate')();

  await dataService.create({
    switchToOfflineRequested: true,
    targetBuildID: onlineBuildId,
    offlineUpdatePath,
  });
}
